import {Component, Input} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {WidgetModel} from '../../../model/widget.model';
import {AlertService} from '../../../../../services/notify/alert.service';
import {WidgetsService} from '../../../services/widgets.service';
import {TFormState} from '../../../../../models/forms.model';

@Component({
    selector: 'app-widget-root-settings',
    templateUrl: './widget-root-settings.component.html',
    styleUrl: './widget-root-settings.component.scss'
})
export class AppWidgetRootSettingsComponent {
    public formState: TFormState
    @Input() widget: WidgetModel
    @Input() widgetSettingsComponent: any

    constructor(
        private widgetsService: WidgetsService,
        private alertService: AlertService,
        private dialogRef: MatDialogRef<AppWidgetRootSettingsComponent>
    ) {
    }

    widgetsUpdateOptions(action: 'Save' | 'Cancel') {
        action === 'Save' ? this.saveWidgetOptions() : this.cancelSaveAction();
    }

    saveWidgetOptions(): void {
        this.formState = 'Submitting'
        this.widgetsService.changeWidgetOptions(this.widget.id, this.widget.options_dict).subscribe({
            next: (data) => {
                this.formState = 'Default'
                this.alertService.setAlert(data.message, 'green')
                this.widgetsService.subWidgetSettingsChanged.next(data.widget);
                setTimeout(() => this.dialogRef.close(), 100);
            },
            error: (err) => {
                this.formState = 'Default'
                this.alertService.setAlert(err.message, 'blue')
            }
        });
    }

    cancelSaveAction() {
        this.dialogRef.close()
    }
}